import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { RouterProvider } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { Menu01, Menu02 } from "@untitledui/icons";
import { SidebarNavigationSimple } from "@/components/application/app-navigation/sidebar-navigation/sidebar-simple";
import { SidebarNavigationSlim } from "@/components/application/app-navigation/sidebar-navigation/sidebar-slim";
import { ButtonUtility } from "@/components/base/buttons/button-utility";
import { CommandSearch } from "@/components/shield/command-search";
import { ThemeToggle } from "@/components/shield/theme-toggle";
import { useNavGroups, useNavRail } from "@/components/admin/nav-config";

const STORAGE_KEY = "admin-sidebar-collapsed";

export function AppLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(STORAGE_KEY) === "1";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  const groups = useNavGroups();
  const railItems = useNavRail();
  const activeUrl = location.pathname;

  return (
    <RouterProvider navigate={(to) => navigate(to)}>
      <div className="flex min-h-screen flex-col bg-primary lg:flex-row">
        {collapsed ? <SidebarNavigationSlim activeUrl={activeUrl} items={railItems} /> : <SidebarNavigationSimple activeUrl={activeUrl} items={groups} />}

        <main className="flex min-w-0 flex-1 flex-col">
          <div className="sticky top-0 z-20 hidden border-b border-secondary bg-primary/80 px-4 py-3 backdrop-blur lg:flex lg:items-center lg:gap-2">
            <ButtonUtility
              size="sm"
              color="tertiary"
              icon={collapsed ? Menu02 : Menu01}
              tooltip={collapsed ? t("shell.expandSidebar") : t("shell.collapseSidebar")}
              onPress={() => setCollapsed((c) => !c)}
            />
            <CommandSearch />
            <div className="ml-auto flex items-center gap-1">
              <ThemeToggle />
            </div>
          </div>

          <div className="flex-1">
            <Outlet />
          </div>
        </main>
      </div>
    </RouterProvider>
  );
}
